import { isProduction } from "../utils/constants";
import { bugsnag_log } from "../utils/bugsnag";

const inFlightChartBars = new Map();

const normalizeScale = (s) => ({
  // legacy aliases
  "1day": "1d",
  "5min": "5m",

  // canonical
  "1min": "1m",
  "5m": "5m",
  "10m": "10m",
  "15m": "15m",
  "30m": "30m",
  "1h": "1h",
  "2h": "2h",
  "3h": "3h",
  "4h": "4h",
  "1d": "1d",
  "1w": "1w",
  "1mo": "1mo",
}[s] || s);

const getChartBars = async ({ tickerId, scale, from = null, to = null, limit = 1000 }) => {
  const normalizedScale = normalizeScale(scale);
  const requestKey = JSON.stringify({
    tickerId: String(tickerId),
    scale: normalizedScale,
    from: from || null,
    to: to || null,
    limit,
  });

  if (inFlightChartBars.has(requestKey)) {
    return inFlightChartBars.get(requestKey);
  }

  const body = JSON.stringify({
    query: `
      query ChartBars($tickerId: ID!, $scale: String!, $from: ISO8601DateTime, $to: ISO8601DateTime, $limit: Int) {
        chartBars(tickerId: $tickerId, scale: $scale, from: $from, to: $to, limit: $limit) {
          datetime
          open
          high
          low
          close
          volume
          vwap
        }
      }`,
    variables: { tickerId, scale: normalizedScale, from, to, limit },
  });

  const request = (async () => {
    try {
      const res = await fetch("/graphql", { method: "POST", headers: { "Content-Type": "application/json" }, body });
      const json = await res.json();
      if (json.errors?.length) throw new Error(json.errors[0].message);
      return json.data.chartBars;
    } catch (err) {
      if (!isProduction) console.error("getChartBars error:", err);
      bugsnag_log(err);
      throw err;
    } finally {
      inFlightChartBars.delete(requestKey);
    }
  })();

  inFlightChartBars.set(requestKey, request);
  return request;
};

export { getChartBars };
